import { useIntl } from 'react-intl';

import parseNumber from '../../../helpers/number/parseNumber';
import LocalizedNumber from '../types/LocalizedNumber';

type InitialOptions = {
    minDecimals?: number;
    maxDecimals?: number;
};

type Options = {
    format: boolean;
};

const useLocalizeNumber = ({ minDecimals, maxDecimals }: InitialOptions) => {
    const intl = useIntl();

    const format = (
        value: number,
        original: string,
        options: Options
    ): LocalizedNumber => {
        if (Number.isNaN(value)) {
            return {
                float: undefined,
                floatAsString: '',
                localized: original,
            };
        }

        return {
            float: value,
            floatAsString: value.toString(10),
            localized: options.format
                ? intl.formatNumber(value, {
                      minimumFractionDigits: minDecimals,
                      maximumFractionDigits: maxDecimals,
                  })
                : original,
        };
    };

    const parseLocalized = (
        value: string,
        options: Options
    ): LocalizedNumber => {
        const floatValue = parseNumber(intl, value);

        return format(floatValue, value, options);
    };

    const parseInternational = (
        value: string,
        options: Options
    ): LocalizedNumber => {
        return format(parseFloat(value), value, options);
    };

    return { parseLocalized, parseInternational };
};

export default useLocalizeNumber;
